<template>
	<div>
		<!-- Files -->
		<core-files-card
			class="mt6"
			id="berkleyProposalFiles"
			filesOf="proposals"
			:list="files"
			:canWrite="false"
			@file:deleted="$emit('file:deleted')"
			@files:uploaded="$emit('file:uploaded')"
		/>
	</div>
</template>

<script>
import CoreFilesCard from "@/modules/core/components/CoreFilesCard"

export default {
	components: {
		CoreFilesCard
	},

	props: {
		files: Array
	}
}
</script>
